module.exports = __webpack_public_path__ + "static/living-space-0a041f1e4a7ebe324d79bc6b8db587a5.png";